export enum AuthApprovalWatchKind {
    DeviceApproval = 'device_approval',
    WebQrPairing = 'web_qr_pairing',
}
